export default __webpack_public_path__ + "static/media/card-project2.849cb7fc.jpg";